// AI-CONTEXT: See docs/methodiek-benchmark-model.md § 1, § 2 en § 8
import { useEffect, useState } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'

/**
 * De cross-organisatie-benchmark op één MSI-output van materialen en
 * coachadviezen: bespaarde CO2 of de besparing op de energierekening.
 *
 * EEN NIVEAU PER HUISHOUDEN, GEEN GROEI. Een huishouden krijgt maatregelen of
 * niet; er is geen voor- en nameting. `benchmarkLevel` is het gemiddelde per
 * huishouden, en `unit` zegt dat er ook bij — die twee horen altijd samen op het
 * scherm, anders leest een gemiddelde als een totaal.
 *
 * DE TWEE OUTPUTS WORDEN NOOIT OPGETELD. Kilogram en euro zijn eigen eenheden;
 * de aanroeper vraagt er één op. Twee aanroepen naast elkaar is de bedoeling.
 *
 * De callable verifieert tenant-lidmaatschap server-side en anonimiseert elke
 * andere organisatie, dus het resultaat is veilig te renderen zoals het komt.
 *
 * @param {'co2Kg'|'privateEur'} output - Welke output wordt vergeleken
 * @param {boolean} [enabled] - Sla de aanroep over wanneer false
 * @returns {{ benchmark: object|null, loading: boolean, error: Error|null }}
 */
const useMaterialOutputBenchmark = (output, enabled = true) => {
    const [benchmark, setBenchmark] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */ (null))

    useEffect(() => {
        if (!enabled || !output) return

        let active = true
        setLoading(true)
        setError(null)
        setBenchmark(null)

        firebase.app().functions('europe-west1')
            .httpsCallable('materialOutputBenchmark')({ callerCompanyId: client, output })
            .then((result) => { if (active) setBenchmark(result.data) })
            // Zichtbaar falen: zonder benchmark toont de kaart een melding en
            // geen getal. Een leeg resultaat zou lezen als 'geen besparing'.
            .catch((err) => { if (active) setError(err) })
            .finally(() => { if (active) setLoading(false) })

        return () => { active = false }
    }, [output, enabled])

    return { benchmark, loading, error }
}

export default useMaterialOutputBenchmark
